import { gql } from '@apollo/client';

export const CALENDAR_LOOKUP = gql`
  query CALENDAR_LOOKUP($input: CalendarLookupInput!) {
    calendarLookup(input: $input) {
      verbose
      ... on DateRangeRawData {
        dateRange {
          c
          r
          p
          n
          a
          k
          t
          f
          l
          z
        }
      }
      ... on DateRangeVerboseData {
        dateRange {
          clientId
          calendarType
          dateType
          rangeType
          periodType
          number
          asOf
          first
          last
          timezone
        }
      }
    }
  }
`;
